module.exports = __webpack_public_path__ + "img/pr-17.16f657a6.png";